import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { Table } from 'primeng/table';
import { Router } from "@angular/router";
import { ConfirmationService, MessageService } from 'primeng/api';
import { TitleCasePipe } from '@angular/common';
import { LazyLoadEvent } from 'primeng/api';
import { Dropdown } from "primeng/dropdown";
import { environment } from 'src/environments/environment';
import { saveAs } from 'file-saver/src/FileSaver';
import * as moment from "moment";
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { maxYearFunction } from 'src/app/_helpers/utility';
import { UserWalletService } from 'src/app/services/userWallet.service';

@Component({
  selector: 'app-user-wallet-report',
  templateUrl: './user-wallet-report.component.html',
  styleUrls: ['./user-wallet-report.component.scss'],
  providers: [MessageService, ConfirmationService, TitleCasePipe]
})
export class UserWalletReportComponent implements OnInit, OnDestroy {

    private destroy$ = new Subject<void>();
    errorMessage = '';
    searchBy: any[];    
    totalRecords: 0;    
    walletlist: any;
    public item: any[] = [];
    loading: boolean;
    paginationOption;
    private lastTableLazyLoadEvent: LazyLoadEvent;
    calvalue: Date;
    ucalvalue: Date;
    dcalvalue: Date;
    yearRange;
    minYear = environment.minYear;
    startDate: Date;
    endDate: Date;
    downloadFlg: boolean;
    downloadwalletlist: any;
    searchby;
    wdcalvalue;
    public hide: boolean = true;
    public sellerCsvFile;
    @ViewChild("dt", { static: false }) public dt: Table;
    @ViewChild("pDropDownId", { static: false }) pDropDownId: Dropdown;
    constructor( private userwalletService: UserWalletService, private router: Router,  private messageService: MessageService, private confirmationService: ConfirmationService) { }

    ngOnInit() {
        this.paginationOption = environment.pagination;
        this.yearRange = this.minYear + ":" + maxYearFunction();
        this.searchBy = [
            { label: 'Created On', value: "created_at" },
            // { label: 'Last Modified On', value: "updated_at" }
        ];
        this.downloadFlg = false;
    }

    clear() {
        this.startDate = null;
        this.endDate = null;
        this.searchby = null;
        this.dt.filter('', 'addTotal', 'contains');
        this.dt.filter('', 'subtractTotal', 'contains');        
        this.dt.filter('', 'userId', 'dateIs');
        this.dt.filter('', 'total', 'contains');
        this.dt.filter('', 'mobileNumber', 'contains');
        this.dt.filter('', 'emailId', 'contains');
        this.dt.filter('', 'firstName', 'contains');
        this.dt.filter('', 'lastName', 'contains');
    }

    loadWallet(event: LazyLoadEvent) {
        this.lastTableLazyLoadEvent = event;
        var query = "?filterByDisable=false";
        var pagenumber = 1;
        var params = "";
        var rows;
        if (event.first != undefined && event.first == 0) {
            pagenumber = event.first + 1;
        } else if (event.first != undefined && event.first > 0) {
            pagenumber = (event.first / event.rows) + 1;
        } else {
            pagenumber = 1;
        }
        if (event.rows != undefined) {
            rows = event.rows;
        } else {
            rows = 10;
        }

        if (this.searchby != undefined && this.startDate != undefined && this.endDate != undefined) {
            params += "&filterByDate=" + this.searchby.value;
            params += "&filterByStartDate=" + moment(this.startDate).format("YYYY-MM-DD");
            params += "&filterByEndDate=" + moment(this.endDate).format("YYYY-MM-DD");
            console.log(params);
        }
        if (event.filters != undefined && event.filters["addTotal"] != undefined) {
            params += "&filterByAddTotal=" + event.filters["addTotal"].value;
        }
        if (event.filters != undefined && event.filters["subtractTotal"] != undefined) {
            params += "&filterBySubtractTotal=" + event.filters["subtractTotal"].value;
        }
        if (event.filters != undefined && event.filters["userId"] != undefined) {
            params += "&filterByUserId=" + event.filters["userId"].value;
        }
        if (event.filters != undefined && event.filters["total"] != undefined) {
            params += "&filterByTotal=" + event.filters["total"].value;
        }
        if (event.filters != undefined && event.filters["mobileNumber"] != undefined) {
            params += "&filterByMobile=" + event.filters["mobileNumber"].value;
        }
        if (event.filters != undefined && event.filters["emailId"] != undefined) {
            params += "&filterByEmail=" + event.filters["emailId"].value;
        }
        if (event.filters != undefined && event.filters["firstName"] != undefined) {
            params += "&filterByFirstName=" + event.filters["firstName"].value;
        }        
        if (event.filters != undefined && event.filters["lastName"] != undefined) {
            params += "&filterByLastName=" + event.filters["lastName"].value;
        }

        // at the time of download hide pagination option
        if (this.downloadFlg == false) {
            if (params != undefined && params != "") {
                query += "&pageSize=" + rows + "&pageNumber=" + pagenumber + params;
            } else {
                query += "&pageSize=" + rows + "&pageNumber=" + pagenumber;
            }
        } else {
            if (params != undefined && params != "") {
                query += params;
            }
        }

        if (event.sortField != undefined && event.sortOrder != undefined) {
            var orderBy = "";
            if (event.sortOrder == 1) {
                orderBy = "DESC";
            } else {
                orderBy = "ASC";
            }
            query += "&sortBy=" + event.sortField + "&orderBy=" + orderBy;
        }        
        this.userwalletService.getUserWalletReportList(query).pipe(takeUntil(this.destroy$)).subscribe(
            (data:any) => {
                if (this.downloadFlg) {
                    this.exportExcelSheet(data.data);
                } else {
                    this.loading = false;
                    this.walletlist = data.data;
                    this.totalRecords = data.totalCount;
                }
            },
            err => {
                this.errorMessage = err.error.message;
            });
    }

    setDownloadFlag() {
        this.downloadFlg = false;
    }

    exportExcel() {
        this.downloadFlg = true;
        this.loadWallet(this.lastTableLazyLoadEvent);
    }

    exportExcelSheet(walletlist) {
        var propertiesRemove = ['id', 'fullName', 'isProfileComplete', 'referral_code', 'registerMode', 'created_at', 'createdby', 'updatedby', 'disable', 'updated_at', 
          'status', 'created_by', 'gender', 'statename', 'cityname', 'countryname', 'zipcode'];
        this.downloadwalletlist = walletlist;
        this.downloadwalletlist.forEach(function (item) {         
            propertiesRemove.forEach(function (prop) {
                delete item[prop];
            });
        });
        import("xlsx").then(xlsx => {
            const worksheet = xlsx.utils.json_to_sheet(this.downloadwalletlist);
            const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
            const excelBuffer: any = xlsx.write(workbook, {
                bookType: "xlsx",
                type: "array"
            });
            this.saveAsExcelFile(excelBuffer, "UserWallet_Report");
        });
    }

    saveAsExcelFile(buffer: any, fileName: string): void {
        import("file-saver").then(FileSaver => {
            let EXCEL_TYPE =
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
            let EXCEL_EXTENSION = ".xlsx";
            const data: Blob = new Blob([buffer], {
                type: EXCEL_TYPE
            });
            let filename;
            filename = fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION;
            saveAs(data, filename);
        });
    }

    ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
